import { createAction, props } from '@ngrx/store';
import { ICan } from 'app/models/can';

export const clearAllItems = createAction('[DalHelper] Clear All Cans');
export const loadItems = createAction('[Module Component] Load Cans');
export const loadItemsSuccess = createAction('[Can API] Load Cans Success', props<{ items: ICan[] }>());
export const loadItemsFailure = createAction('[Can API] Load Cans Failure', props<{ error: any }>());

export const setItem = createAction('[Can Page] Set selected Can', props<{ id: string }>());
export const setEan = createAction('[Can Page] Set selected Can EAN', props<{ ean: string }>());

export const addItem = createAction('[Beverage detail page / Can Page] Add Can', props<{ id: string, item: ICan }>());
export const addItemSuccess = createAction('[Can API] Add Cans Success', props<{ item: ICan }>());
export const addItemFailure = createAction('[Can API] Add Cans Failure', props<{ error: any }>());

export const softUpdate = createAction('[Beer Detail Page] Soft Update Can', props<{ id: string, data: any, uid: string }>());
export const softUpdateSuccess = createAction('[Beverage API] Soft Update Can Success', props<{ id: string, data: any }>());
export const softUpdateFailure = createAction('[Beverage API] Soft Update Can Failure', props<{ error: any }>());


export const updateItem = createAction('[Beer Detail Page] Update Can', props<{ item: ICan }>());
export const updateItemSuccess = createAction('[Can API] Update Can Success');
export const updateItemFailure = createAction('[Can API] Update Can Failure', props<{ error: any }>());


export const deleteItem = createAction('[Can Detail Page] Delete Can', props<{ id: string }>());
export const deleteItemSuccess = createAction('[Can API] Delete Cans Success', props<{ id: string }>());
export const deleteItemFailure = createAction('[Can API] Delete Cans Failure', props<{ error: any }>());
